module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADvSURBVFiF7dfBTQMxEIXh/61SBE3sdrDUkFBByDFlQA85AhUQaiAdZJugCLTDASzBASljZCVI77vPzJNlS2MwMzOzC6Kaon5cL+k0RERXNVSameM4HZ5e0rXZgv769hlYZet+sZ9eH28yBanA/bheIu2BN0K7IN7TEQGhBYotcEXEKnPSi9SkTgMBhHbT4eG+JmzRjxtQ3NFpAE4OnLqD5c7WnuyPXl89su+g6tGckwO35sCtOXBrDtyaA7fmwK2lAkuaKfvsH5UepeepcoPnOCKBYtuPm+o189sC/9kzVZv0r75IxTk/oWZmZnZRPgAdcFEYrDdSjAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/img-rect.png
// module id = 8NFM
// module chunks = 0